import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

import {
  fetchEvent,
  deleteEvent,
  updateEvent
} from '../../actions/events'

import DeleteForm from '../../components/common/DeleteForm'
import { EventUpdateForm as EventForm } from '../../components/Events/EventForm'

function mapStateToProps (state) {
  return {
    event: state.events.event.data,
    accessToken: state.auth.user.access.access_token
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchEvent: (id, key) => dispatch(fetchEvent(id, key)),
    updateEvent: (data, key) => dispatch(updateEvent(data, key)),
    deleteEvent: (id, key) => dispatch(deleteEvent(id, key))
  }
}

export class EventUpdate extends React.Component {
  componentWillMount () {
    this.props.fetchEvent(this.props.match.params.id, this.props.accessToken)
  }

  handleDelete (e) {
    return this.props.deleteEvent(this.props.event.id, this.props.accessToken)
  }

  handleSubmit (e) {
    return this.props.updateEvent({ ...e }, this.props.accessToken)
  }

  render () {
    return (
      <div className='content'>
        <div className='main-header'>
          <h2>Update Event {this.props.event && this.props.event.name}</h2>
          <em><Link to='/events'>back to event list</Link></em>
        </div>
        <div className='main-content'>
          <div className='row'>
            <div className='col-md-8'>
              {this.props.event
                ? <div>
                  <EventForm
                    onSubmit={this.handleSubmit.bind(this)}
                    initialValues={this.props.event}
                  />
                  <DeleteForm onClick={this.handleDelete.bind(this)} />
                </div>
                : <div>loading</div>
              }
            </div>
            <div className='col-md-4' />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(EventUpdate))
